import React, { Component } from "react";
import { Link } from "react-router-dom";
import StarRatings from "react-star-ratings";
import Modal from "react-modal";

import axios from "axios";
import { serviceOptions } from "../services/serviceOptions.ts";
import { UsersService, RestaurantsService, ReviewsService } from "../services/";
import authHeader from "../services/auth-header.js";
import AuthService from "../services/auth.service.js";

const axiosInstance = axios.create({
  headers: authHeader(),
  baseURL: process.env.REACT_APP_API_PREFIX,
});
serviceOptions.axios = axiosInstance;

export default class Restaurants extends Component {
  constructor(props) {
    super(props);
    

    this.state = {
      content: "",
      restaurantDetail: false,
      restaurantDetailContent: "",
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  
      authError(error) {
        //TODO: there's an initial request firing getting a 401, but THEN ok for some reason?
        //if (error.response.status === 401) {
          //AuthService.logout(this);
          //return;
        //}
          /*
        this.setState({
          content: []
          content:
            (error.response &&
              error.response.data &&
              error.response.data.detail) ||
            error.detail ||
            error.toString()
        }
        );
        */
      }

  handleOpenModal (restaurant_id) {
        this.setState({ restaurantDetail: restaurant_id });
    RestaurantsService.getRestaurantV10RestaurantsRestaurantIdGet({'restaurantId':restaurant_id}).then(
      response => { this.setState({restaurantDetailContent: response});
      }, error => {this.authError(error)}
    );
  }

    handleCloseModal () {
      this.setState({ restaurantDetail: false, restaurantDetailContent: "" });
      this.props.history.push("/restaurants/");
    }

  componentDidMount() {
    Modal.setAppElement('#main');

    RestaurantsService.getRestaurantsV10RestaurantsGet().then(
      response => {
        this.setState({
          content: response
        });
      },
      error => {this.authError(error)}
    );
  }

  renderReview(category, review) {
    if (review === false) {
      return "";
    }
    return (
      <>
      <h2>{category}</h2>
      <div>
      <StarRatings starDimension="14px" starSpacing="2px" rating={review.stars} />
      <p>{review.comment}</p>
      <p>&#8212;{review.created_date_date.toLocaleString()}</p>
      <p>TODO: if responded to</p>
      </div>
      </>
    );
  }

  renderDetailContent() {
    const { restaurantDetailContent } = this.state;
    const content = restaurantDetailContent;
    // sort reviews by score then date
    // best will be newest best; worst will be oldest worst.
    var reviews = content ? [].concat(content.reviews) : [];
    var best = false;
    var worst = false;
    if (reviews.length > 0) {
      for (var item of reviews) {
        item.created_date_date = new Date(item.created_date);
      }
      reviews.sort(function(a, b) { return (b.stars !== a.stars) ? b.stars - a.stars : b.created_date_date - a.created_date_date; });
      best = reviews[0]
      worst = reviews[reviews.length-1]
      if (worst.stars === best.stars) {
        worst = false
      }
    }
    const best_render = this.renderReview("Best", best);
    const worst_render = this.renderReview("Worst", worst);
    return (
      <>
                  <header className="jumbotron">
                    <h3>{restaurantDetailContent.name}</h3>
<StarRatings starDimension="14px" starSpacing="2px" rating={restaurantDetailContent.reviews_average} /> ({restaurantDetailContent.reviews_N}&nbsp;review(s))
                  </header>
      <div className="container">
        { restaurantDetailContent.reviews_N > 0 ? (
          <>
          {best_render}
          {worst_render}
      <table style={{width:"100%"}}>
        <thead>
        <tr><th>Comment</th><th>Rating</th><th></th></tr>
        </thead>
        <tbody>
        {
        //<tr><td colspan="3" style={{fontStyle: 'italic'}}>{JSON.stringify(content)}</td></tr>
        }
          {
            reviews.map((item, index) => (
              <tr key={item.id}><td>{item.comment}</td><td><StarRatings starDimension="14px" starSpacing="2px" rating={item.stars} /></td><td>{item.created_date_date.toLocaleString()}</td></tr>
            ))
          }
        </tbody>
      </table>
          </>
        ) : ( <p>No Reviews</p> ) }
      </div>
      </>
    )
  }

  render() {
    const { content, restaurantDetail, restaurantDetailContent } = this.state;
    return (
      <div className="container">
      { /*
        <header className="jumbotron">
          <h3>Restaraunts</h3>
        </header>
        */ }
              <Modal
                 isOpen={restaurantDetail !== false}
                 contentLabel="Restaurant detail"
                 shouldCloseOnOverlayClick={false}
              >
                <button onClick={this.handleCloseModal} style={{"position": "absolute", "top": "10px", "right": "10px"}}>X</button>
      { !restaurantDetailContent ? (
        <p>Loading...</p>
      ) : (
        this.renderDetailContent()
      )}
              </Modal>
      <table style={{width:"100%"}}>
      { content ? ( 
        <>
        <thead>
        <tr><th>Restaurant</th><th>Rating</th><th></th></tr>
        </thead>
        <tbody>
        {
        //<tr><td colspan="3" style={{fontStyle: 'italic'}}>{JSON.stringify(content)}</td></tr>
        }
          {
            content.map((item, index) => (<tr key={item.id}><td><Link to={'/restaurants/'+item.id} onClick={() => this.handleOpenModal(item.id)}>{item.name}</Link></td><td><StarRatings starDimension="14px" starSpacing="2px" rating={item.reviews_average} /></td><td>({item.reviews_N}&nbsp;review(s))</td></tr>))
          }
        </tbody>
        </>
        ) : (
          <tbody>
          <tr><td>Loading...</td></tr>
          </tbody>
        )
      }
      </table>
      </div>
    );
  }
}
